import React from "react";
import anime from 'animejs';

import './nav.css';

const Nav = () => <nav className='nav-container' style={{ opacity: 0 }} ref={(ref) => {
    anime({
        targets: ref,
        delay: 4500,
        opacity: 1,
        duration: 1000,
        easing: 'easeInOutSine'
    })
}}>
    <a className="nav-container-link"
        href="https://www.linkedin.com/in/joseph-milne-968b92110/"
        rel="noopener noreferrer"
        target="_blank">LinkedIn</a>
    <a className="nav-container-link"
        href="https://github.com/JobenM"
        rel="noopener noreferrer"
        target="_blank">Github</a>
</nav>

export default Nav;
